import { render, staticRenderFns } from "./ImageGuidelines.vue?vue&type=template&id=0c43cb28&scoped=true&"
import script from "./ImageGuidelines.vue?vue&type=script&lang=js&"
export * from "./ImageGuidelines.vue?vue&type=script&lang=js&"
import style0 from "./ImageGuidelines.vue?vue&type=style&index=0&id=0c43cb28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c43cb28",
  null
  
)

export default component.exports